import styled from 'styled-components';

export const SRoot = styled.div<{ $isVertical: boolean }>`
  display: flex;
  position: relative;
  flex: 1;
  min-height: 0;
  height: 100%;
  background: white;

  ${({ $isVertical }) => ($isVertical ? 'flex-direction: column;' : '')};
`;

export const SDrag = styled.div<{
  $isVertical: boolean;
  $size: number;
}>`
  position: relative;
  z-index: 2;
  cursor: col-resize;

  ${({ $isVertical, $size }) => {
    if ($isVertical) {
      return `height: ${$size}px;`;
    }

    return `width: ${$size}px;`;
  }}

  &:before,
  &:after {
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
  }

  &:before {
    width: 1px;
    background-color: #bfbfbf;
    z-index: 1;
    margin: auto;
    left: 0;
    right: 0;
  }

  &:after {
    transition: 0.3s;
    width: calc(100% + 4px);
    opacity: 0;
    background-color: rgb(217 217 217 / 50%);
    left: -2px;
  }

  &:hover:after {
    opacity: 1;
  }
`;

export const SPanel = styled.div<{
  $isVertical: boolean;
  $width: number;
  $height: number;
  $padding: number;
}>`
  ${({ $isVertical, $padding, $height, $width }) => {
    if ($isVertical) {
      return `height: ${$height}px; width: 100%;`;
    }

    return `width: ${$width}px; padding: 0 ${$padding}`;
  }}
`;
